import React, { FC } from "react";
import { StyledColDiv } from "./DoorList";
import { UnitObj } from "../../../util/quoteCartStorage";
import { Typography } from "@mui/material";
import noAccess from "../../../util/noAccess";
import { styled } from "@mui/material/styles";

const StyledTypography = styled(Typography)({
  fontWeight: "bold",
  borderBottom: "1px dashed black",
});

interface Props {
  door: UnitObj;
}

const Details: FC<Props> = ({ door }) => {
  const dimensionsText = (whole: string, fraction: string | undefined) => {
    if (!fraction) {
      return `${whole}"`;
    }
    return `${whole} ${fraction}"`;
  };

  const dimensionsWidth = dimensionsText(door.unitSize, door.unitSizeFraction);
  const dimensionsHeight = dimensionsText(door.height, door.heightFraction);

  const isAluminum = door.material === "All Aluminum";

  return (
    <StyledColDiv>
      {door.location && (
        <Typography variant="body2">
          <span style={{ fontWeight: "bold" }}>Location: </span>
          {door.location}
        </Typography>
      )}
      {door.doorType.includes("Corner") ? (
        <StyledColDiv>
          <StyledTypography variant="body2">
            Bi-fold {door.cornerType} Corner
          </StyledTypography>

          <Typography
            style={{
              fontWeight: "bold",
            }}
            variant="body2"
          >
            L: {door.exactConfig} {dimensionsWidth} R: {door.cornerConfigRight}{" "}
            {dimensionsText(
              door.cornerWidthRight || "",
              door.cornerWidthFractionRight
            )}
            X {dimensionsHeight}
          </Typography>
        </StyledColDiv>
      ) : door.doorType.includes("Combo") ? (
        <StyledColDiv>
          <StyledTypography variant="body2">
            {door.doorType}
          </StyledTypography>

          <Typography
            style={{
              fontWeight: "bold",
            }}
            variant="body2"
          >
            {door.comboUnitLeft === "Door" 
            ? door.exactConfig 
            : door.comboWindowConfig} 
            {" "}
            {door.comboUnitLeft === "Door" 
            ? dimensionsWidth 
            : dimensionsText(door.comboWindowUnitSize || "", door.comboWindowUnitSizeFraction)} 
            {" "}
            X
            {" "}
            {door.comboUnitLeft === "Door" 
            ? dimensionsHeight 
            : dimensionsText(door.comboWindowHeight || "", door.comboWindowHeightFraction)}
            {" "}
            {door.comboUnitRight === "Door" 
            ? door.exactConfig 
            : door.comboWindowConfig}{" "}
            {door.comboUnitRight === "Door" 
            ? dimensionsWidth 
            : dimensionsText(door.comboWindowUnitSize || "", door.comboWindowUnitSizeFraction)}
            {" "}
            X {" "}{door.comboUnitRight === "Door" 
            ? dimensionsHeight 
            : dimensionsText(door.comboWindowHeight || "", door.comboWindowHeightFraction)}
          </Typography>
        </StyledColDiv>
      ) : door.doorType === "Pivot" ? (
        <StyledTypography variant="body2">
          Pivot - {door.exactConfig.replace("Pivot", "Inswing")}{" "}
          {dimensionsWidth}X {dimensionsHeight}
        </StyledTypography>
      ) : isAluminum &&
        !door.doorType.includes("Bi-fold") &&
        door.doorType.includes("Window") ? (
        <StyledTypography variant="body2">
          {door.doorType} - {dimensionsWidth} X {dimensionsHeight}
        </StyledTypography>
      ) : (
        <StyledTypography variant="body2">
          {door.doorType} - {door.exactConfig} {dimensionsWidth} X{" "}
          {dimensionsHeight}
          {!isAluminum &&
          door.stileCategory !== "Pico" &&
          (noAccess.includes(door.exactConfig) ||
            door.doorType === "Bi-fold Window") ? (
            <>
              {" "}
              <br />{" "}
              <span style={{ color: "red", fontSize: 12 }}>
                *No access from exterior
              </span>{" "}
            </>
          ) : (isAluminum ||
              door.stileCategory === "Pico") &&
            door.withExtSbolt === "No" &&
            noAccess.includes(door.exactConfig) &&
            door.doorType !== "Bi-fold Window" ? (
            <>
              {" "}
              <br />{" "}
              <span style={{ color: "red", fontSize: 12 }}>
                *No access from exterior
              </span>{" "}
            </>
          ) : null}
        </StyledTypography>
      )}
      <Typography variant="body2">{door.material}</Typography>
      {!isAluminum && (
        <Typography variant="body2">
          Wood Species -{" "}
          <span style={{ fontWeight: "bold" }}>{door.woodAbbrev}</span>
        </Typography>
      )}
      {door.material !== "All Wood" && !isAluminum && (
        <Typography variant="body2">
          Clad Color -{" "}
          <span style={{ fontWeight: "bold" }}>
            {door.exteriorCladColor?.includes("Custom")
              ? "Custom Color"
              : door.exteriorCladColor}
          </span>
        </Typography>
      )}
      {isAluminum && (
        <Typography variant="body2">
          Aluminum Color -{" "}
          <span style={{ fontWeight: "bold" }}>
            {door.splitFinish === "Split Finish"
              ? `Int. ${door.aluminumColor?.replace(
                  " (upcharge applies)",
                  ""
                )} Ext. ${door.aluminumColorExterior?.replace(
                  " (upcharge applies)",
                  ""
                )}`
              : door.aluminumColorExterior}
          </span>
        </Typography>
      )}
    </StyledColDiv>
  );
};

export default Details;
